export const DEVICE_CLASSES = {
  bigscreen: 1199,
  desktop: 991,
  tablet: 768,
  phone: 575,
};
